import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment as env } from '@environments/environment'
import { BehaviorSubject, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ApiResult } from '../../../shared/model/Index';
import { IOfficialVisit, IStudentOfficialVisitOccurence } from '../model/officialvisit';
import { Guid } from 'guid-typescript';

@Injectable({ providedIn: 'root' })

export class OfficialVisitService {
    public showSpinner = new BehaviorSubject(false);
    constructor(private http: HttpClient) { }

    get(id: Guid) {
        return this.http.get<ApiResult<IOfficialVisit>>(env.apiUrl + 'StudentOfficialVisit/' + id).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }
    getNcaaId(id: Guid) {
        return this.http.get<ApiResult<string>>(env.apiUrl + 'StudentOfficialVisit/NcaaId/' + id).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }
    post(officialVisit: IOfficialVisit) {
        return this.http.post<ApiResult<number>>(env.apiUrl + 'StudentOfficialVisit', officialVisit).pipe(catchError(this.handleError))
    }
    getOccurence(id: Guid) {
        return this.http.get<ApiResult<IStudentOfficialVisitOccurence[]>>(env.apiUrl + 'StudentOfficialVisit/GetOccurence/' + id).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }
    createOfficialVisitOccurence(officialVisitOccurence: IStudentOfficialVisitOccurence) {
        return this.http.post<ApiResult<number>>(env.apiUrl + 'StudentOfficialVisit/CreateOfficialVisitOccurence', officialVisitOccurence).pipe(catchError(this.handleError))
    }
    updateOfficialVisitOccurence(officialVisitOccurence: IStudentOfficialVisitOccurence) {
        return this.http.put<ApiResult<number>>(env.apiUrl + 'StudentOfficialVisit/updateOfficialVisitOccurence', officialVisitOccurence).pipe(catchError(this.handleError))
    }
    deleteOfficialVisitOccurence(id: Guid) {
        return this.http.delete<ApiResult<number>>(env.apiUrl + 'StudentOfficialVisit/deleteOfficialVisitOccurence/' + id);
    }
    put(officialVisit: IOfficialVisit) {
        return this.http.put<ApiResult<number>>(env.apiUrl + 'StudentOfficialVisit', officialVisit);
    }
    handleError(error: HttpErrorResponse) {
        return throwError(error);
    }
}